import React, { Component } from 'react';
import shieldOrange from '../../assets/shield-orange.png';
import shieldBlue from '../../assets/shield-blue.png';
import shieldGreen from '../../assets/shield-green.png';

export default class Regulation extends Component {
  render() {
    return (
      <section id="peraturan-dan-ketentuan-menjadi-psre-berinduk">
        <p style={{fontSize: '18px', color: '#0085C7',fontWeight: '600', marginBottom: '25px'}}>Peraturan & Ketentuan Menjadi PSrE Berinduk</p>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 pt-3 pb-3">
            <table className="table-borderless mb-3">
              <tr>
                <td>
                  <img className="mr-3" src={shieldOrange} alt="shield-orange" style={{width: '25px', height: '25px'}}/>
                </td>
                <td>
                  <span style={{fontSize: '15px', fontWeight: '600'}}>Terdaftar</span>
                </td>
              </tr>
            </table>
            <table className="table-borderless mb-3">
              <tr>
                <td>
                  <img className="mr-3" src={shieldBlue} alt="shield-orange" style={{width: '25px', height: '25px'}}/>
                </td>
                <td>
                  <span style={{fontSize: '15px', fontWeight: '600'}}>Tersertifikasi</span>
                </td>
              </tr>
            </table>
            <table className="table-borderless">
              <tr>
                <td>
                  <img className="mr-3" src={shieldGreen}alt="shield-orange" style={{width: '25px', height: '25px'}}/>
                </td>
                <td>
                  <span style={{fontSize: '15px', fontWeight: '600'}}>Berinduk</span>
                </td>
              </tr>
            </table>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <p style={{fontSize: '13px'}}>
              Apakah sekarang kalian bertanya-tanya, gimana sih prosedur untuk jadi PSrE berinduk? Apa aja sih syarat-syaratnya? Ribet tidak ya prosesnya? Ada berapa langkah sih buat bisa bener - bener jadi PSrE berinduk?
              <br/><br/>
              Jadi, ada tiga status tingkatan pengakuan Penyelenggara Sertifikasi Elektronik yaitu: Penyelenggara Sertifikasi Elektronik terdaftar; Penyelenggara Sertifikasi Elektronik tersertifikasi; Penyelenggara Sertifikasi Elektronik berinduk.
            </p>
          </div>
        </div>
        <p style={{fontSize: '13px', marginTop: '20px'}}>Untuk tau perbedaan dari masing-masing tingkatan pengakuan, yuk cek Halaman <a target="_blank" href="persyaratan-psre.html" style={{color: '#0085C7'}}>Syarat Menjadi PSrE.</a></p>
      </section>
    )
  }
}
